import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SuccessComponent } from '../shared/modals/success/success.component';
import { ErrorComponent } from '../shared/modals/error/error.component';
import { ResponseComponent } from '../shared/modals/response/response.component';
import { LoadingSpinnerComponent } from '../shared/modals/loading-spinner/loading-spinner.component';
import { AssignStudentScheduleConfirmComponent } from '../shared/modals/assign-student-schedule-confirm/assign-student-schedule-confirm.component';
import { VerifyMasterComponent } from '../shared/modals/verify-master/verify-master.component';
import { ConfirmTransmitComponent } from '../shared/modals/confirm-transmit/confirm-transmit.component';
// import { AddVestComponent } from '../shared/modals/add-vest/add-vest.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
    
  modalRefSucess!: BsModalRef;
  modalRefError!: BsModalRef;
  modalRefResponse!: BsModalRef;
  modalRefLoadingSpinner!: BsModalRef;
  modalRefUpdateApplicationStatus!: BsModalRef;
  modalRefUpdatePreEnlistmentStatus!: BsModalRef;
  modalRefStudentFilter!: BsModalRef;
  modalRefAssignStudentScheduleConfirm!: BsModalRef;
  modalRefSelection!: BsModalRef;
  modalRefCreateScheduleDetailsConfirm!: BsModalRef;
  modalRefCreateEmployee: BsModalRef;
  modalRefVerifyMaster: BsModalRef;
  modalRefConfirmTransmit: BsModalRef;

  constructor(
    private modalService: BsModalService
  ) {}

    
  successModal(message: any){
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered success-modal'
    }

    return this.modalRefSucess = this.modalService.show(SuccessComponent, config);
  }

	hideSuccessModal(){
    if(this.modalRefSucess){
			this.modalRefSucess.hide();
    }
	}

  errorModal(message: any){
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal modal-dialog-centered success-modal'
    }

    return this.modalRefError = this.modalService.show(ErrorComponent, config);
  }

	hideErrorModal(){
    if(this.modalRefError){
			this.modalRefError.hide();
    }
	}

  openResponseModal(message: any){
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered response-modal'
    }

    return this.modalRefSucess = this.modalService.show(ResponseComponent, config);
  }

	hideResponseModal(){
    if(this.modalRefSucess){
			this.modalRefSucess.hide();
    }
	}

  showLoadingSpinner(){
		const config: any = {
			backdrop: true,
			ignoreBackdropClick: true,
			keyboard: false,
			class: 'modal-dialog-centered loading-spinner'
		}

		return this.modalRefLoadingSpinner = this.modalService.show(LoadingSpinnerComponent, config);
  }

  hideLoadingSpinner(){
    if(this.modalRefLoadingSpinner){
			this.modalRefLoadingSpinner.hide();
    }
	}
  
  showAssignStudentScheduleConfirm(data){
    const initialState = {
      data,
    }
		const config: any = {
			backdrop: true,
      initialState,
			ignoreBackdropClick: true,
			keyboard: false,
			class: 'modal-dialog-centered success-modal'
		}

		return this.modalRefAssignStudentScheduleConfirm = this.modalService.show(AssignStudentScheduleConfirmComponent, config);
  }

  hideAssignStudentScheduleConfirm(){
    if(this.modalRefAssignStudentScheduleConfirm){
			this.modalRefAssignStudentScheduleConfirm.hide();
    }
	}

  showVerifyMaster (data) {
    const initialState = {
      data,
    }
		const config: any = {
			backdrop: true,
      initialState,
			ignoreBackdropClick: true,
			keyboard: false,
			class: 'modal-dialog-centered success-modal'
		}

    return this.modalRefVerifyMaster = this.modalService.show(VerifyMasterComponent, config);
  }

  hideVerifyMaster (): void {
    if(this.modalRefVerifyMaster){
			this.modalRefVerifyMaster.hide();
    }
  }

  showConfirmTransmit (data) {
    const initialState = {
      data,
    }
		const config: any = {
			backdrop: true,
      initialState,
			ignoreBackdropClick: true,
			keyboard: false,
			class: 'modal-dialog-centered success-modal'
		}

    return this.modalRefConfirmTransmit = this.modalService.show(ConfirmTransmitComponent, config);
  }

  hideConfirmTransmit (): void {
    if(this.modalRefConfirmTransmit){
			this.modalRefConfirmTransmit.hide();
    }
  }
}
